import React from "react";
import { Box } from "../../../design-system";
import Loading from "../../../loading/loading";
import TabErrorState from "./TabErrorState";
import TabEmptyState from "./TabEmptyState";

interface LibraryTabLayoutProps {
  loading: boolean;
  error: string | null;
  isEmpty: boolean;
  emptyMessage: string;
  children: React.ReactNode;
}

const LibraryTabLayout: React.FC<LibraryTabLayoutProps> = ({
  loading,
  error,
  isEmpty,
  emptyMessage,
  children,
}): JSX.Element => {
  if (loading) return <Loading />;
  // Only show the error screen when there's nothing to show. If we already have
  // data on screen, a later error must never blank it out.
  if (error && isEmpty) return <TabErrorState message={error} />;
  if (isEmpty) return <TabEmptyState message={emptyMessage} />;

  return (
    <Box
      sx={{
        // Flat like the homepage — no grey card; content sits on the dark page.
        backgroundColor: "transparent",
        padding: 0,
        minHeight: "400px",
        height: "600px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Box>
  );
};

export default LibraryTabLayout;
